import React, { useState } from 'react';

// create an order context
const OrderContext = React.createContext();

// create provider (component that will live at a higher level)
export function OrderProvider({ children }) {
  // we need to stick state in here
  const [order, setOrder] = useState([]);
  return (
    <OrderContext.Provider value={[order, setOrder]}>
      {children}
    </OrderContext.Provider>
  );
}

export default OrderContext;
